import { useToasted } from './useToasted';

export const useCopyText = () => {
    const toasted = useToasted();

    const copyText = (text) => {
        navigator.clipboard.writeText(text);
        toasted.success(`${text} copied to clipboard.`);
    };

    return {
        copyText,
    };
};
